import * as React from 'react';
import { useDispatch } from 'react-redux';

import { closeNewbuildingBookingConfirm } from '../../../actions/newbuildingBookedFromDeveloper';
import { NewbuildingBookedFromDeveloperSuccessModal } from '../../../components/NewbuildingBookedFromDeveloperSuccessModal';

export const BookedFromDeveloperSuccessModalContainer = () => {
  const dispatch = useDispatch();
  const onClose = React.useCallback(() => {
    dispatch(closeNewbuildingBookingConfirm());
  }, [closeNewbuildingBookingConfirm]);

  return <NewbuildingBookedFromDeveloperSuccessModal onClick={onClose} />;
};
